import { Avatar, ButtonBase, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface PaloAccountLogoProps {
    name: string;
    src?: string;
    /** No logo before the first save: there is nothing to attach it to yet. */
    disabled?: boolean;
    onAdd: () => void;
    onRemove: () => void;
}

/**
 * The logo of a member or a supplier, small in the head of the section: beside
 * the grid it took the room of a column and left the fields 58 pixels wide
 * (#2261). PoolAvatar puts a 40-pixel button over its circle, which at this
 * size covers it, so the circle is the button here.
 */
export const PaloAccountLogo = ({ name, src, disabled, onAdd, onRemove }: PaloAccountLogoProps): ReactElement => {
    const initials = name.replace(/[^0-9a-z]/gi, '').substring(0, 2);

    return (
        <Tooltip
            title={
                <FormattedMessage
                    id={
                        disabled
                            ? 'app.contactsAndOrganizations.detail.avatarSaveFirst'
                            : src
                            ? 'app.common.logoRemove'
                            : 'app.common.logoAdd'
                    }
                />
            }
        >
            <span>
                <ButtonBase
                    disabled={disabled}
                    onClick={src ? onRemove : onAdd}
                    sx={{ borderRadius: '50%', opacity: disabled ? 0.5 : 1 }}
                >
                    <Avatar
                        src={src}
                        alt={name}
                        sx={{
                            width: 30,
                            height: 30,
                            fontSize: 12,
                            backgroundColor: tokens.color.surfaceAlt,
                            color: tokens.color.ink2,
                            border: `1px solid ${tokens.color.line}`,
                            '& > img': { objectFit: 'contain' },
                        }}
                    >
                        {initials}
                    </Avatar>
                </ButtonBase>
            </span>
        </Tooltip>
    );
};
